export class MaintenanceUserRole {
  public id: number = 0;
  public role: string = "";
  public desc: string = "";
}
